import { CreateRenderFunction } from "@pdfking/reactivity/preact"
import { contains, filter, last, length, map } from "@pdfking/rfunc"
import { All, Zip } from "@pdfking/tfunc"
import autocomplete from "../constants/autocomplete"

export const Sizedatalist = CreateRenderFunction({
  computed: {
    objects() {
      const state = autocomplete()
      const response = state[this.autocomplete]
      return response ? response.objects : null
    },
    sizes() {
      if (this.objects) {
        const unit_filter = length(this.units)
          ? (formatted: string) =>
              contains(this.units, last(formatted.split(" ")))
          : (_formatted: string) => true

        const is_contained = (measures: number[]) =>
          All(
            Zip(this.min, measures, this.max),
            ([min, current, max]: [number, number, number]) =>
              current >= min && current <= max
          )

        return map(
          ([name, formatted, ..._sizes]: [string, string, ...number[]]) => [
            name,
            formatted,
          ],
          filter(
            ([_name, formatted, ...sizes]: [string, string, ...number[]]) =>
              unit_filter(formatted) && is_contained(sizes),
            this.objects
          )
        )
      }
      return null
    },
  },
  props: {
    autocomplete: "",
    id: "",
    max: [] as number[],
    min: [] as number[],
    target: null as string | null,
    units: [] as string[],
  },
  render() {
    if (!this.objects) return null
    return (
      <datalist id={this.id}>
        {this.sizes.map(([name, size]: [string, string]) => (
          <option
            dangerouslySetInnerHTML={{ __html: name }}
            key={size}
            value={size}
          />
        ))}
      </datalist>
    )
  },
})
